import * as types from './constants';

// Get Unmasking Invitation
export const getUnmaskingInvitationRequest = data => (
  { type: types.GET_UNMASKING_INVITATION_REQUEST, payload: data }
);

export const getUnmaskingInvitationDone = data => (
  { type: types.GET_UNMASKING_INVITATION_DONE, payload: data }
);

export const getUnmaskingInvitationFailed = errors => (
  { type: types.GET_UNMASKING_INVITATION_FAILED, payload: errors }
);